import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AILoader } from 'ai-components-ui-library/components/loading/AILoader';
import { DataFetchingClient, DataFetchingClientProvider, useDataFetchingClient } from 'data-fetching-client';
import { useAcademyChatSession } from '../hooks/useAcademyChatSession';
import { useAcademyChat } from '../hooks/useAcademyChat';
import { AcademyChatProvider } from './AcademyChatProvider';
import { AcademyAIAssistantChat } from './AcademyAIAssistantChat';
import { jsx as _jsx } from "react/jsx-runtime";
const dataFetchingClient = new DataFetchingClient();
function ConnectedChat({
  systemConfig,
  channelName,
  onClose,
  onNewChat,
  initialPrompt
}) {
  const {
    messages,
    isStreaming,
    error,
    sendMessage,
    stopStream
  } = useAcademyChat({
    channelName,
    systemConfig,
    initialPrompt
  });
  return /*#__PURE__*/_jsx(AcademyAIAssistantChat, {
    messages: messages,
    isStreaming: isStreaming,
    error: error,
    onSendMessage: sendMessage,
    onStopStream: stopStream,
    onClose: onClose,
    onNewChat: onNewChat
  });
}
function AcademyAIAssistantChatContainerInner({
  onClose,
  onNewChat,
  modifiedSystemPrompt,
  initialPrompt
}) {
  const session = useAcademyChatSession({
    modifiedSystemPrompt
  });
  if (session.error) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      padding: "300",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        color: "text-alert-default",
        children: session.error
      })
    });
  }
  if (!session.isReady || !session.thread || session.userId === null) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(AILoader, {
        isFinished: false
      })
    });
  }
  return /*#__PURE__*/_jsx(AcademyChatProvider, {
    thread: session.thread,
    userId: session.userId,
    children: /*#__PURE__*/_jsx(ConnectedChat, {
      systemConfig: session.systemConfig,
      channelName: session.thread.ablyChannelId,
      onClose: onClose,
      onNewChat: onNewChat,
      initialPrompt: initialPrompt
    })
  });
}
export function AcademyAIAssistantChatContainer({
  onClose,
  modifiedSystemPrompt,
  initialPrompt
}) {
  const [chatKey, setChatKey] = useState(0);
  const handleNewChat = useCallback(() => setChatKey(k => k + 1), []);
  const existingClient = useDataFetchingClient(false); // retrieve existing client if present
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: existingClient !== null && existingClient !== void 0 ? existingClient : dataFetchingClient,
    children: /*#__PURE__*/_jsx(AcademyAIAssistantChatContainerInner, {
      onClose: onClose,
      onNewChat: handleNewChat,
      modifiedSystemPrompt: modifiedSystemPrompt,
      initialPrompt: initialPrompt
    }, chatKey)
  });
}